import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {EnvStorageKeyValueObject} from "../../../data/value-object/env/EnvStorageKeyValueObject";
import {EnvStorageKeySearchOption} from "../../../data/search-option/env/EnvStorageKeySearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {EnvStorageKeyIO} from "../../../io/EnvIO";
import {EnvStorageKeyDescription} from "../../../data/description/env/EnvStorageKeyDescription";
import {EnvStorageKeyDescriptor} from "../../../data/descriptor/env/EnvStorageKeyDescriptor";
import ListOption from "../../ListOption";
import {EnvStorageKeySearchOptionDescription} from "../../../data/description/env/EnvStorageKeySearchOptionDescription";
import {
    applyEnvStorageKeySearchOption,
    EnvStorageKeySearchOptionField
} from "../../search-option-field/env/EnvStorageKeySearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<EnvStorageKeyValueObject[]>([])
    const option = useStatePair<EnvStorageKeySearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={EnvStorageKeyIO}
                items={items}
                option={option.value}
                index={index}
                description={EnvStorageKeyDescription}
                descriptor={EnvStorageKeyDescriptor}
                showPost
                onPostClick={() => document.location = '/env/storageKeys/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/env/storageKeys/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={EnvStorageKeySearchOptionDescription}
                fields={EnvStorageKeySearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyEnvStorageKeySearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={EnvStorageKeyDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}